import { FC, SVGProps } from 'react'

export const LightningBolt: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M13.1043 2.28595C13.4146 2.38557 13.625 2.67417 13.625 3.00005V9.25005H19C19.2811 9.25005 19.5386 9.40722 19.6671 9.65722C19.7955 9.90723 19.7735 10.2081 19.6098 10.4366L11.7348 21.4366C11.5451 21.7016 11.206 21.8138 10.8957 21.7142C10.5854 21.6145 10.375 21.3259 10.375 21.0001V14.7501H5C4.71892 14.7501 4.46143 14.5929 4.33294 14.3429C4.20446 14.0929 4.22655 13.792 4.39017 13.5635L12.2652 2.56347C12.4549 2.29849 12.794 2.18633 13.1043 2.28595ZM6.45932 13.2501H11.125C11.5392 13.2501 11.875 13.5858 11.875 14.0001V18.664L17.5407 10.7501H12.875C12.4608 10.7501 12.125 10.4143 12.125 10.0001V5.33608L6.45932 13.2501Z"
			fill="currentColor"
		/>
	</svg>
)
